import '../layout';
import qs from 'qs';

function get_list(people_url, class_ids) {
    if (class_ids === undefined) {
        class_ids = []
    }

    const url = people_url + qs.stringify({
        'class_ids': class_ids
    }, {
        addQueryPrefix: true,
        arrayFormat: 'repeat'
    });

    // Fetch the species list from server through an Ajax request.
    fetch(url).then(
        response => response.ok ? response.text() : Promise.reject(response)
    ).then(
        str => document.getElementById('list_people').innerHTML = str
    ).catch(
        error => console.log(error)
    );
}

document.addEventListener('DOMContentLoaded', e => {
    const select_schemes = document.getElementById('schemes'),
        select_classifications = document.getElementById('classifications'),
        select_subclass = document.getElementById('subclass'),
        selection_ul = document.getElementById('selection'),
        selection_container = document.getElementById('selection_container'),
        main = document.getElementById('main');

    let hierarchy = null,
        selection = [];

    select_schemes.addEventListener('change', build_classifications);
    select_classifications.addEventListener('change', build_subclass);

    function clear_select(elem) {
        elem.disabled = true;
        
        while(elem.hasChildNodes()) {
            elem.removeChild(elem.lastChild);
        }

        return elem;
    }

    function show_or_hide(select) {
        if (select.options.length) {
            select.disabled = false;
            select.style.display = '';
        } else {
            select.disabled = true;
            select.style.display = 'none';
        }
    }

    function build_schemes() {
        clear_select(select_schemes);

        const opt = document.createElement('option');
        opt.appendChild(document.createTextNode('...'));
        select_schemes.appendChild(opt);

        hierarchy.forEach(function(cl) {
            const opt = document.createElement('option');
            opt.value = cl.id;
            opt.appendChild(document.createTextNode(cl.description));
            opt.setAttribute('data-txt', cl.description);

            select_schemes.appendChild(opt);
        });

        select_schemes.disabled = false;
    }

    function build_classifications(e) {
        const selected_scheme = e.target.value;

        clear_select(select_classifications);
        show_or_hide(clear_select(select_subclass));

        const opt = document.createElement('option');
        opt.appendChild(document.createTextNode('...'));
        select_classifications.appendChild(opt);

        hierarchy.forEach(function(level1) {
            if (level1.id == selected_scheme) {
                level1.children.forEach(function(level2) {
                    const opt = document.createElement('option');
                    opt.value = level2.id;
                    opt.appendChild(document.createTextNode(level2.term));
                    opt.setAttribute('data-txt', level2.term);

                    select_classifications.appendChild(opt);
                });
            }
        });

        show_or_hide(select_classifications);
    }

    function build_subclass(e) {
        const selected_classification = e.target.value;

        clear_select(select_subclass);

        hierarchy.forEach(function(level1) {
            if (level1.id == select_schemes.value) {
                level1.children.forEach(function(level2) {
                    if (level2.id == select_classifications.value) {
                        level2.children.forEach(function(level3) {
                            const opt = document.createElement('option');
                            opt.value = level3.id;
                            opt.appendChild(document.createTextNode(level3.term));
                            opt.setAttribute('data-txt', level3.term);

                            select_subclass.appendChild(opt);
                        })
                    }
                })
            }
        });

        show_or_hide(select_subclass);
    }

    // Get data
    fetch(main.getAttribute('data-scheme_url'), {
        headers: { 
            'Accept' : 'application/json'
        }
    }).then(
        response => response.ok ? response.json() : Promise.reject(response)
    ).then(
        json => {
            hierarchy = json.schemes;
            build_schemes();
        }
    ).catch(errors => console.log(errors));

    document.getElementById('add').addEventListener('click', function(e) {
        const scheme = select_schemes.options[select_schemes.selectedIndex],
            classi = select_classifications.options[select_classifications.selectedIndex],
            subclass = select_subclass.options[select_subclass.selectedIndex];
            
        let selected_id = null;

        const li = document.createElement('li');

        if (scheme && scheme.value) {
            selected_id = scheme.value;
            li.appendChild(document.createTextNode(scheme.getAttribute('data-txt')));
        }

        if (classi && classi.value) {
            selected_id = classi.value;
            li.appendChild(document.createTextNode(' -> ' + classi.getAttribute('data-txt')));
        }

        if (subclass && subclass.value) {
            selected_id = subclass.value;
            li.appendChild(document.createTextNode(' -> ' + subclass.getAttribute('data-txt')));
        }

        if (selected_id && selection.indexOf(selected_id) == -1) {
            selection.push(selected_id);
            get_list(main.getAttribute('data-people_url'), selection);

            const remove = document.createElement('a'),
                remove_img = document.createElement('i');
            
            remove.href = '#';
            remove_img.className = "fa fa-times";
            remove_img.style = "margin-left: 10px;"
            remove.appendChild(remove_img);

            remove.addEventListener('click', function(e) {
                e.preventDefault();
                remove.parentNode.parentNode.removeChild(li);
                selection.splice(selection.indexOf(classi.value), 1);
                selection_container.style.display = selection.length == 0 ? 'none' : '';
                get_list(main.getAttribute('data-people_url'), selection);
            });

            li.appendChild(remove);
            selection_ul.appendChild(li);
            selection_container.style.display = '';
        }
    });

    document.getElementById('remove_all_filters').addEventListener('click', function(e) {
        selection = [];
        selection_container.style.display = 'none';

        while(selection_ul.hasChildNodes()) {
            selection_ul.removeChild(selection_ul.lastChild);
        }

        get_list(main.getAttribute('data-people_url'), selection);
    });

    get_list(main.getAttribute('data-people_url'));
});
